import { render, staticRenderFns } from "./infoIcons.vue?vue&type=template&id=2da903d0&scoped=true"
import script from "./infoIcons.vue?vue&type=script&lang=js"
export * from "./infoIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da903d0",
  null
  
)

export default component.exports